import { whereToFilter } from "@contember/client";
const wrapFilterInHasOnes = (path, filter) => {
  for (let i = path.length - 1; i >= 0; i--) {
    const current = path[i];
    if (current.reducedBy === void 0) {
      filter = {
        [current.field]: filter
      };
    } else {
      filter = {
        [current.field]: {
          and: [filter, whereToFilter(current.reducedBy)]
        }
      };
    }
  }
  return filter;
};
export {
  wrapFilterInHasOnes
};
//# sourceMappingURL=wrapFilterInHasOnes.js.map
